import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { About } from './components/About';
import { Button } from './components/Button';
import { Catalog } from './components/Catalog';
import { Footer } from './components/Footer';
import { Form } from './components/Form';
import { Links } from './components/Links';
import { Media } from './components/Media';
import { Social } from './components/Social';
import { Welcome } from './components/Welcome';
import { AppProvider } from './contexts/App';
import { Container } from './styles';
const isRunningOnServer = () => {
    return typeof window === 'undefined';
};
const getSectionComponent = (site, section) => {
    if (!section.active) {
        return null;
    }
    switch (section.type) {
        case 'welcome':
            return (_jsx(Welcome, { section: section }, section.id));
        case 'about':
            return _jsx(About, { section: section }, section.id);
        case 'catalog':
            return (_jsx(Catalog, { section: section }, section.id));
        case 'links':
            return _jsx(Links, { section: section }, section.id);
        case 'social':
            return (_jsx(Social, { section: section }, section.id));
        case 'form':
            return _jsx(Form, { section: section }, section.id);
        case 'media':
            return _jsx(Media, { section: section }, section.id);
        case 'button':
            return (_jsx(Button, { section: section }, section.id));
        default:
            null;
    }
};
export const SitePage = ({ site, contextProps, theme, layout }) => {
    const callPageLoad = useCallback(async () => {
        if (contextProps.pageLoadLink) {
            try {
                await fetch(contextProps.pageLoadLink, { method: 'GET' });
            }
            catch (e) {
                console.log(e);
            }
        }
    }, [contextProps]);
    useEffect(() => {
        if (!isRunningOnServer()) {
            callPageLoad();
        }
    }, [callPageLoad]);
    return (_jsx(AppProvider, { value: { site, contextProps }, children: _jsx(StyledThemeProvider, { theme: { ...theme, ...layout }, children: _jsxs(Container, { backgroundColor: theme.primary, textColor: theme.secondary, "$layout": layout, children: [_jsx("div", { className: "content-container", children: site.sections.map((section) => getSectionComponent(site, section)) }), !site.hideSignature && _jsx(Footer, {})] }) }) }));
};
export { Player } from './components/Media/components/Player';
export { BehanceIcon } from './components/Social/icons/Behance';
export { DribbbleIcon } from './components/Social/icons/Dribbble';
export { FacebookIcon } from './components/Social/icons/Facebook';
export { InstagramIcon } from './components/Social/icons/Instagram';
export { LinkedinIcon } from './components/Social/icons/Linkedin';
export { MediumIcon } from './components/Social/icons/Medium';
export { TiktokIcon } from './components/Social/icons/Tiktok';
export { TwitchIcon } from './components/Social/icons/Twitch';
export { TwitterIcon } from './components/Social/icons/Twitter';
export { VimeoIcon } from './components/Social/icons/Vimeo';
export { WhatsappIcon } from './components/Social/icons/Whatsapp';
export { YoutubeIcon } from './components/Social/icons/Youtube';
